interface LegalDocumentCardProps {
  title: string;
  description: string;
  checked?: boolean;
  onToggle: () => void;
  onRead: () => void;
  readLabel?: string;
}

export default function LegalDocumentCard({
  title,
  description,
  checked = false,
  onToggle,
  onRead,
  readLabel = 'Ler documento →',
}: LegalDocumentCardProps) {
  return (
    <div
      role="button"
      tabIndex={0}
      aria-pressed={checked}
      onClick={onToggle}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onToggle();
        }
      }}
      className={`group flex w-full items-center justify-between gap-6 rounded-2xl border px-5 py-5 text-left backdrop-blur-xl transition-all duration-300 hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-violet-400/50 focus:ring-offset-2 focus:ring-offset-[#020817] ${
        checked
          ? 'border-violet-400/55 bg-violet-500/10 shadow-[0_0_38px_rgba(139,92,246,0.18)]'
          : 'border-violet-500/20 bg-[#0f172a]/75 shadow-[0_0_28px_rgba(139,92,246,0.08)] hover:border-violet-400/45 hover:shadow-[0_0_34px_rgba(139,92,246,0.16)]'
      }`}
    >
      <div className="flex min-w-0 items-start gap-4">
        <span
          className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-lg border shadow-[inset_0_0_12px_rgba(15,23,42,0.85)] transition-all duration-300 ${
            checked
              ? 'border-violet-300 bg-violet-500/35 shadow-[0_0_18px_rgba(167,139,250,0.24)]'
              : 'border-violet-500/30 bg-slate-950/70'
          }`}
        >
          <span
            className={`h-2.5 w-2.5 rounded-sm transition-all duration-300 ${
              checked ? 'scale-100 bg-violet-300' : 'scale-0 bg-transparent'
            }`}
          />
        </span>

        <span className="min-w-0 pr-1">
          <span
            className={`block text-sm font-semibold transition-colors duration-300 ${
              checked ? 'text-white' : 'text-slate-50'
            }`}
          >
            {title}
          </span>

          <span className="mt-1.5 block text-xs leading-5 text-slate-400">
            {description}
          </span>
        </span>
      </div>

      <button
        type="button"
        onClick={(event) => {
          event.stopPropagation();
          onRead();
        }}
        className="inline-flex shrink-0 items-center gap-1 text-sm font-semibold text-violet-400 transition-colors duration-300 hover:text-violet-300 focus:outline-none focus:ring-2 focus:ring-violet-400/50 focus:ring-offset-2 focus:ring-offset-[#020817]"
      >
        <span>{readLabel.replace(' →', '')}</span>
        <span className="transition-transform duration-300 group-hover:translate-x-1">
          →
        </span>
      </button>
    </div>
  );
}
